// extracted by mini-css-extract-plugin
export var logo = "logo_name-module--logo--74ea9";
export var logoName = "logo_name-module--logoName--3fbc6";